var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3-.5A3.5,3.5,0,1,1-.5,3,3.5,3.5,0,0,1,3-.5Zm0,6A2.5,2.5,0,1,0,.5,3,2.5,2.5,0,0,0,3,5.5Z",
    transform: "translate(15 2)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3-.5A3.5,3.5,0,1,1-.5,3,3.5,3.5,0,0,1,3-.5Zm0,6A2.5,2.5,0,1,0,.5,3,2.5,2.5,0,0,0,3,5.5Z",
    transform: "translate(3 9)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3-.5A3.5,3.5,0,1,1-.5,3,3.5,3.5,0,0,1,3-.5Zm0,6A2.5,2.5,0,1,0,.5,3,2.5,2.5,0,0,0,3,5.5Z",
    transform: "translate(15 16)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83,4.48a.5.5,0,0,1-.251-.068L-.252.432a.5.5,0,0,1-.18-.684.5.5,0,0,1,.684-.18l6.83,3.98a.5.5,0,0,1-.252.932Z",
    transform: "translate(8.59 13.51)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.48a.5.5,0,0,1-.432-.248.5.5,0,0,1,.18-.684l6.82-3.98a.5.5,0,0,1,.684.18.5.5,0,0,1-.18.684L.252,4.412A.5.5,0,0,1,0,4.48Z",
    transform: "translate(8.59 6.51)",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.51ffb7f271a6c3cb9c6247a9614d9930.svg";
export { ForwardRef as ReactComponent };